import React, { Component } from "react";
import Modal from "../../components/Modal/modal";
import Link from "gatsby-link";

import Image from "components/Image";
import SignUp from "components/Buttons/SignUp";

class VideoSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      embedUrl: `https://www.youtube.com/embed/${
        this.props.youtubeVideoId
      }?rel=0&amp;showinfo=0`,
      shareUrl: `https://www.youtube.com/watch?v=${this.props.youtubeVideoId}`
    };
  }

  openModal = () => {
    console.log("Opening the video modal");
    this.setState({
      modal: true
    });
  };

  closeModal = () => {
    this.setState({
      modal: false
    });
  };

  renderModal() {
    if (this.state.modal) {
      console.log(`First render with video modal.. - ${this.state.embedUrl}`);
      return (
        <Modal close={this.closeModal}>
          <iframe
            width="100%"
            height="330"
            src={`${this.state.embedUrl}`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        </Modal>
      );
    }
    return null;
  }

  render() {
    const textStyle = this.props.textColor
      ? { color: this.props.textColor }
      : {};

    return (
      <section>
        <div
          className="bg-lightGrey py-5"
          style={{ background: this.props.bgColor || "#F6F6F6" }}
        >
          <div className="hide-h2 container marketingSection">
            <div className="row align-items-center">
              <div className="col-md-5">
                {this.props.header && (
                  <h2 style={textStyle}>{this.props.header}</h2>
                )}
                {this.props.subHeader && (
                  <h3 style={textStyle}>{this.props.subHeader}</h3>
                )}
                {this.props.paragraph && (
                  <p style={textStyle}>{this.props.paragraph}</p>
                )}

                {this.props.social ? (
                  <div style={{ marginTop: "10px" }}>
                    <a
                      target="_blank"
                      href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                        this.state.shareUrl
                      )}`}
                      className="fb-xfbml-parse-ignore"
                    >
                      <span
                        className="icon-facebook-alt"
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                          color: this.props.textColor || "#000"
                        }}
                      />
                    </a>
                    <a
                      href={`https://twitter.com/home?status=${encodeURIComponent(
                        this.state.shareUrl
                      )}%20%20%40Yoco_ZA`}
                      target="_blank"
                    >
                      <span
                        className="icon-twitter-alt"
                        style={{
                          display: "inline-block",
                          marginRight: "10px",
                          color: this.props.textColor || "#000"
                        }}
                      />
                    </a>
                    <a
                      href={`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
                        this.state.shareUrl
                      )}&title=&summary=&source=`}
                      target="_blank"
                      style={{
                        display: "inline-block",
                        color: this.props.textColor || "#000"
                      }}
                    >
                      <div className="icon-linkedin" />
                    </a>
                  </div>
                ) : (
                  ""
                )}
                {this.props.learnMoreLink && (
                  <p>
                    <Link
                      to={this.props.learnMoreLink}
                      className="tinyLink test-of-works"
                    >
                      Learn more
                    </Link>
                  </p>
                )}
                {this.props.buttonText ? (
                  <SignUp
                    text={this.props.buttonText}
                    href={this.props.buttonLink}
                    target={this.props.buttonTarget}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-md-7 text-center ">
                <Image
                  src={`${this.props.previewImage}`}
                  className="img-fluid"
                  alt=""
                  style={{ maxWidth: "500px", cursor: "pointer" }}
                  onClick={this.openModal}
                />
              </div>
            </div>
          </div>
        </div>
        {this.renderModal()}
      </section>
    );
  }
}

export default VideoSection;



// WEBPACK FOOTER //
// ./src/sections/layouts/videoSection.js